import React, {useRef} from 'react';
import { ArrowLong, SelectArrow } from '../../../../assets/img/svg/icons';
import Swal from 'sweetalert2';
import { sendFormData } from '../../../../Api';
import InputMask from "react-input-mask";
import Informativo from './informativo';

const Input: React.FC<{ name: string; id: string; type: string; mask?: string; desc: string; required?: boolean }> = ({ name, id, type, desc, mask, required = false }) => (
    <label htmlFor={id} className="bg-white text-sm w-full relative flex items-center p-2 rounded-md">
        <div className="shrink-0 pl-2 h-8 flex items-center translate-y-[1px]">{desc}</div>

        {mask ? 
            <InputMask name={name} id={id} type={type} className="w-full h-8 px-2 text-sm outline-none" mask={mask} required={required} />
        :
            <input name={name} id={id} type={type} className="w-full h-8 px-2 text-sm outline-none" required={required} />
        }
    </label>
);

const Textarea: React.FC<{ name: string; id: string; desc: string; required?: boolean }> = ({ name, id, desc, required = false }) => (
    <label htmlFor={id} className="bg-white text-sm w-full relative flex p-2 rounded-md">
        <div className="shrink-0 pl-2 mb-1">{desc}</div>

        <textarea name={name} id={id} className="w-full px-2 text-sm outline-none resize-none min-h-24" required={required} />
    </label>
);

const Select: React.FC<{ name: string; id: string; desc: string; options: { value: string; label: string }[]; required?: boolean }> = ({ name, id, desc, options, required = false }) => (
    <label htmlFor={id} className="bg-white text-sm w-full relative flex items-center p-2 rounded-md">
        <div className="shrink-0 pl-2 h-8 flex items-center translate-y-[1px]">{desc}</div>

        <select name={name} id={id} className="w-full h-8 px-2 pr-8 text-sm outline-none appearance-none" required={required}>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>

        <SelectArrow className='absolute right-4 pointer-events-none w-5 h-5 object-contain' />
    </label>
);

const InfoSection: React.FC<{}> = () => {
    const formRef = useRef<HTMLFormElement>(null);
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
    
        if (formRef?.current) {
            const formData = new FormData(formRef?.current);
    
            const data = {
                name: formData.get("nome"),
                email: formData.get("email"),
                phone: formData.get("celular"),
                subject: formData.get("assunto"),
                message: formData.get("mensagem"),
            };

            if(!data.name){
                Swal.fire({
                    title: "Aviso!",
                    text: "Preencha seu nome!",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
                return ;
            }
            if(!data.email){
                Swal.fire({
                    title: "Aviso!",
                    text: "Preencha seu e-mail!",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
                return ;
            }
            if(!data.phone){
                Swal.fire({
                    title: "Aviso!",
                    text: "Preencha seu telefone!",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
                return ;
            }
            // if(!data.subject){
            //     Swal.fire({
            //         title: "Aviso!",
            //         text: "Preencha o assunto!",
            //         icon: "warning",
            //         confirmButtonText: "OK",
            //     });
            //     return ;
            // }
            if(!data.message){
                Swal.fire({
                    title: "Aviso!",
                    text: "Preencha sua mensagem!",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
                return ;
            }
    
            try {
                //await sendFormData("contato", data);
                
                Swal.fire({
                    title: "Sucesso!",
                    text: "Mensagem enviada com sucesso.",
                    icon: "success",
                    confirmButtonText: "OK",
                });
                } catch (error) {
                Swal.fire({
                    title: "Erro!",
                    text: "Ocorreu um erro ao enviar a mensagem.",
                    icon: "error",
                    confirmButtonText: "Tentar novamente",
                });
            }
        }
    };
    return (
        <section className='py-12'>
            <div className="max-w-screen-lg mx-auto lg:px-4">
                <form action="" onSubmit={handleSubmit} ref={formRef} className="bg-light-yellow rounded-3xl py-12 px-4 md:px-8 relative before:content-[''] before:h-full before:w-full before:top-0 before:left-1/2 before:-translate-x-1/2 before:bg-main-blue/50 before:rounded-3xl before:absolute before:-rotate-3 before:-z-10 before:hidden lg:before:block">
                    <h2 className="text-center font-semibold text-2xl">
                        Seja um expositor <br />
                        fale com nossos consultores
                    </h2>

                    <Informativo />

                    <div className="mt-8 grid md:grid-cols-2 gap-1 max-w-[500px] mx-auto">
                        <div className="md:col-span-2">
                            <Input type='text' name='nome' id='nome' desc='Nome:' />
                        </div>

                        <div className="col-span-1">
                            <Input type='email' name='email' id='email' desc='E-mail:' />
                        </div>

                        <div className="col-span-1">
                            <Input type='text' name='tel' id='tel' desc='Telefone:' mask="(99) 99999-9999" />
                        </div>

                        {/* <div className="md:col-span-2">
                            <Select name='evento' id='evento' desc='Escolha um evento:' options={[
                                { value: '', label: '' },
                            ]} />
                        </div> */}

                        <div className="md:col-span-2">
                            <Textarea name="mensagem" id="mensagem" desc="Mensagem:" />
                        </div>
                    
                        <div className="mt-8 md:col-span-2 flex justify-center">
                            <button className="bg-main-pink rounded-full text-center gap-3 inline-flex justify-center items-center p-4 uppercase text-sm font-semibold transition-all duration-200 w-full hover:bg-main-blue text-white max-w-60" type="submit">
                                Enviar
                                <ArrowLong />
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default InfoSection;